import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SensorType } from 'src/api'
import { APIList } from 'src/interfaces'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  params?: {
    limit?: number
    offset?: number
    sort?: string
  }
  options?: Omit<UseQueryOptions<unknown, Error, APIList<SensorType>>, 'queryKey' | 'queryFn'>
}

export const useSensorTypesRequest = ({ params = {}, options }: RequestParams = {}) => {
  const api = useApiInstance()
  return useQuery<unknown, Error, APIList<SensorType>>(
    [Entities.SensorType, JSON.stringify(params)],
    async () => {
      const { limit, offset, sort } = params
      const { data } = await api.v1AdminSensorsTypesGet(limit, offset, sort)
      return data as APIList<SensorType>
    },
    { ...options }
  )
}
